export const addDiscountPurchase = async (
  total,
  discountPurchase,
  setTotal,
  setTotalDiscount,
  tecnopuntos = 0,
  setTecnopuntos = 0,
) => {
  if (discountPurchase !== null) {
    const discount_percentage = parseInt(discountPurchase.Porcentaje) / 100;
    const new_total = total - total * discount_percentage;
    const discount_total = total * discount_percentage;

    setTotal(parseInt(new_total));
    setTotalDiscount(parseInt(discount_total));
  }

  if (tecnopuntos !== 0 && total > 0) setTotal(total - tecnopuntos);

  if (total <= 0) setTecnopuntos(0);
};
